import { render } from "./InstanceList.vue?vue&type=template&id=27a41d4c&scoped=true&ts=true"
import script from "./InstanceList.vue?vue&type=script&lang=ts"
export * from "./InstanceList.vue?vue&type=script&lang=ts"

import "./InstanceList.vue?vue&type=style&index=0&id=27a41d4c&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a41d4c"]])

export default __exports__